import React from "react";
import { TripItemType } from "src/utils/ApiSchema";

interface Props {
  icon: string;
  label: string;
  type: TripItemType;
}

function IconWithText(props: Props) {
  return (
    <div className="flex items-center mt-[10px]">
      <img
        src={props.icon}
        className={`dark:invert ${props.type === TripItemType.Background ? "invert dark:invert-0" : ""}`}
      />
      <p
        className={`ml-[10px] min-w-[100px] text-left ${props.type === TripItemType.Background ? "text-black" : "text-white"}`}
      >
        {props.label}
      </p>
    </div>
  );
}

export default IconWithText;
